export default class InvoiceLine {
  private readonly _description: string | null;
  private readonly _pricePerPiece: Number;
  private readonly _quantity: Number;
  private readonly _service: string;
  private readonly _type: string;
  constructor({
                description,
                pricePerPiece,
                quantity,
                service,
                type,
              }) {
    this._description = description;
    this._pricePerPiece = pricePerPiece;
    this._quantity = quantity;
    this._service = service;
    this._type = type;
  }

  get description(): string | null {
    return this._description;
  }

  get pricePerPiece(): Number {
    return this._pricePerPiece;
  }

  get quantity(): Number {
    return this._quantity;
  }

  get service(): string {
    return this._service;
  }

  get type(): string {
    return this._type;
  }


}
